import { useEffect } from "react";

export default function Modal({ isOpen, onClose, title, message, type = "success" }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // prevent background scroll
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const typeStyles = {
    success: "bg-green-100 text-green-700 border-green-400",
    error: "bg-red-100 text-red-700 border-red-400",
    warning: "bg-yellow-100 text-yellow-700 border-yellow-400",
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 sm:px-0">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      ></div>

      {/* Modal Content */}
      <div className="relative bg-white w-full max-w-sm sm:max-w-md rounded-xl shadow-lg p-6 z-10">
        {/* Title */}
        <h2
          className={`text-lg sm:text-xl font-semibold mb-3 border-b pb-2 ${
            type === "success"
              ? "text-green-600"
              : type === "error"
              ? "text-red-600"
              : "text-yellow-600"
          }`}
        >
          {title}
        </h2>

        {/* Message */}
        <p className="text-sm sm:text-base text-gray-700 mb-6">{message}</p>

        {/* Footer Button */}
        <div className="flex justify-center">
          <button
            onClick={onClose}
            className={`px-4 py-2 text-sm sm:text-base rounded-lg font-medium transition-all ${
              type === "success"
                ? "bg-green-600 text-white hover:bg-green-700"
                : type === "error"
                ? "bg-red-600 text-white hover:bg-red-700"
                : "bg-yellow-500 text-white hover:bg-yellow-600"
            }`}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
